import {AbstractReactComponent} from 'mc/lib';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Button, Card, Col, Row} from 'reactstrap';
import {UserActions} from '../actions';
import {UserSubjekt} from '../components';

class UserProfilePage extends AbstractReactComponent {

    componentDidMount() {
        this.dispatch(UserActions.fetchIfNeeded());
    }

    render() {
        return <Row>
            <Col md={{size: 6, offset: 3}} style={{marginTop: "60px"}}>
                <Card block>
                    <h3>Uživatelský profil</h3>
                    <hr/>
                    <UserSubjekt/>
                </Card>
                <Link to={serverContextPath}>
                    <Button block color="secondary" className="mt-4 pull-right">Zpět na seznam žádostí</Button>
                </Link>
            </Col>
        </Row>
    }
}

export default connect()(UserProfilePage);
